export default "__VITE_ASSET__40dbe232__"